import withHeightFitContent from "hocs/withHeightFitContent";
import useScrollMemory from "hooks/useScrollMemory";
import Content from "./Content";
import { ConstructorTabProps } from "./types";

const ContentWithHeightFitContent = withHeightFitContent(Content);
const selectionModeMaxHeightOffset = { xs: 128, lg: 96 };

const ConstructorTab = ({
  fieldArray,
  form,
  isEditable,
  heightFitContentSignal,
  selectionMode,
}: ConstructorTabProps) => {
  const { ref } = useScrollMemory({ timeoutDelay: 700 });

  return (
    <ContentWithHeightFitContent
      fieldArray={fieldArray}
      form={form}
      isEditable={isEditable}
      refProp={ref}
      additionalMaxHeightOffset={selectionMode ? selectionModeMaxHeightOffset : undefined}
      recalculateSignal={[heightFitContentSignal, selectionMode]}
    />
  );
};

export default ConstructorTab;
